import { Redirect, useLocation } from 'react-router-dom';

import { store } from 'state/store';

type RedirectComponentProps = {
  path: string;
};

export const RedirectComponent = ({ path }: RedirectComponentProps) => {
  const location = useLocation();

  return (
    <Redirect
      exact
      to={{
        pathname: path,
        search: location.search,
        state: { store: store.getState() }
      }}
    />
  );
};
